<template>
    <b-container class="mt-3 col-md-6">
        <b-card no-body class="m-auto" v-if="!orderShow">
            <b-tabs pills card align="center">

                <!--ORDER tab-->
                <b-tab :title="$t('Order')" active>
                    <b-card-text>

                        <b-list-group class="text-left m-auto border border-primary">

                            <b-col v-if="order.lenght" class="text-center">There are no items</b-col>

                            <b-list-group-item >
                                <b-badge variant="primary" v-if="order.DropAddress" class="position-absolute" style="left: 5px;top: 5px;">{{$t('Drop')}}</b-badge>
                                <b-badge variant="primary" v-if="order.LoadAddress" class="position-absolute" style="left: 5px;top: 5px;">{{$t('Load')}}</b-badge>

                                <b-col class="d-flex pr-0">
                                    <b-icon-geo-alt class="mt-1" font-scale="2.5" />

                                    <!--for Drop-->
                                    <b-col class="ml-0 " v-if="order.DropAddress">
                                        <p class="m-0">{{order.DropAddress}}</p>
                                        <p class="m-0 text-secondary">{{order.DropName}}</p>
                                    </b-col>
                                    <!--for Load-->
                                    <b-col class="mx-0 " v-if="order.LoadAddress">
                                        <p class="m-0">{{order.LoadAddress}}</p>
                                        <p class="m-0 text-secondary">{{order.LoadName}}</p>
                                    </b-col>

                                    <!--<b-icon-caret-down-fill class="m-auto" font-scale="2.5" />-->
                                </b-col>
                                <!--instruction-->
                                <b-list-group class="mt-3">
                                    <b-col md="12">
                                        {{$t('Instruction')}}:
                                    </b-col>
                                    <b-col md="12">
                                        {{order.ShipmentDriverInstruction}}
                                    </b-col>
                                </b-list-group>
                                <!--shipmentCustomerName-->
                                <b-list-group class="mt-3">
                                    <b-col md="12">
                                        {{$t('ShipmentCustomerName')}}:
                                    </b-col>
                                    <b-col md="12">
                                        {{order.ShipmentCustomerName}}
                                    </b-col>
                                </b-list-group>
                                <!--shipmentCustomerPhone-->
                                <b-list-group class="mt-3">
                                    <b-col md="12">
                                        {{$t('ShipmentCustomerPhone')}}:
                                    </b-col>
                                    <b-col md="12">
                                        {{order.ShipmentCustomerPhone}}
                                    </b-col>
                                </b-list-group>
                                <!--order items-->
                                <b-list-group class="mt-3">
                                    <b-form-group v-model="orderDetails">
                                        <b-list-group-item v-for="(item,index) in orderDetails" :key="index" class="d-flex flex-column  m-0" href="#">

                                            <b-col md="12">
                                                <b-row class="justify-content">
                                                    <b-col md="6" class="product-col">
                                                        <b-row>
                                                            <label :for="'product'+item.ProductId">{{item.Product}}:</label>
                                                        </b-row>
                                                        <b-row>
                                                            <vue-number-input :id="'product'+item.ProductId" :step="1" :min="0" inline controls :value="item.Quantity" pattern="[0-9]*" @change="updateOrderDetailsQuantity(item.DimensionId, $event)"></vue-number-input>
                                                            <!--<b-form-input pattern="[0-9]*" :id="'product'+item.ProductId" :value="item.Quantity" @input="updateOrderDetails($event, item.ProductId)" type="number"></b-form-input>-->
                                                        </b-row>
                                                    </b-col>
                                                    <b-col md="5" class="bottle-col">
                                                        <b-row class="ml-2">
                                                            <span>{{$t('BottleYear')}}: <h4>{{item.Jaar}}</h4></span>
                                                        </b-row>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="12">
                                                <label :for="'note'+item.DimensionId">{{$t('Note')}}:</label>
                                            </b-col>
                                            <b-col md="12">
                                                <b-form-input :id="'note'+item.DimensionId" inline :value="item.ShipmentDimDelNote" @change="updateOrderDetailsNote(item.DimensionId, $event)"></b-form-input>
                                            </b-col>
                                        </b-list-group-item>
                                    </b-form-group>
                                </b-list-group>
                                <!--<b-button variant="success" class="my-2 w-100">Confirm</b-button>--> 
                            </b-list-group-item>

                        </b-list-group>
                    </b-card-text>

                </b-tab>

                <!--RETURN GOODS tab-->
                <b-tab :title="$t('ReturnGoods')">
                    <b-card-text>

                        <b-list-group class="mt-3">
                            <b-form-input class="mb-3" type="text" v-model="goodsSearch" :placeholder="$t('SearchGoods')" v-on:keyup.enter="setFocusGoods"/>
                            <b-form-group>
                                <b-form-checkbox-group id="checkbox-group-2" name="flavour-2">

                                    <b-list-group-item v-for="(item,index) in filteredGoodsList" :key="index" class="d-flex flex-column m-0">

                                        {{item.Name}}:
                                        <b-col md="12" class="mt-2 ml-2">
                                            <vue-number-input :id="'return_product'+item.ObjectId" :step="1" :min="0" inline controls :value="item.Quantity" pattern="[0-9]*" @change="updateReturnGoodsList($event, item.ObjectId)"></vue-number-input>
                                        </b-col>

                                    </b-list-group-item>

                                </b-form-checkbox-group>
                            </b-form-group>

                        </b-list-group>


                    </b-card-text>
                </b-tab>
                
                <!--EXTRA tab-->
                <b-tab :title="$t('Extra')">
                    <b-card-text>

                        <b-list-group class="mt-3">
                            <b-form-input class="mb-3" type="text" v-model="extraSearch" :placeholder="$t('SearchGoods')" v-on:keyup.enter="setFocusExtra"/>
                            <b-form-group>
                                <b-form-checkbox-group id="checkbox-group-3" name="flavour-3">

                                    <b-list-group-item v-for="(item,index) in filteredExtraList" :key="index" class="d-flex flex-column m-0">

                                        {{item.Name}}:
                                        <b-col md="12" class="mt-2 ml-2">
                                            <vue-number-input :id="'extra_product'+item.ObjectId" :step="1" :min="0" inline controls :value="item.Quantity" pattern="[0-9]*" @change="updateExtraList($event, item.ObjectId)"></vue-number-input>
                                        </b-col>

                                    </b-list-group-item>

                                </b-form-checkbox-group>
                            </b-form-group>

                        </b-list-group>


                    </b-card-text>
                </b-tab>

            </b-tabs>
        </b-card>

        <ConfirmOrder @status-changed="updateModalCompartmentsShow" :orderDetails="orderDetails" :returnGoodsList="returnGoodsList" :extraList="extraList" :tripLineId="order.TripLineId" :shipmentId="order.ShipmentId"></ConfirmOrder>
    </b-container>

</template>

<script>
    import { mapGetters, mapState } from "vuex";
    import { SETORDERDETAILS } from "actions/ordersDetails";
    import { SETRETURNGOOD } from "actions/returnGoodsList";
    import { SETEXTRA } from "actions/extraList";
    import ConfirmOrder from "components/ConfirmOrder";

    export default {
        name: "OrderDetails",
        components: {
            ConfirmOrder
        },
        data() {
            return {
                order: this.$store.getters.getOrderById(this.$attrs.id),
                goodsSearch: '',
                extraSearch: '',
                orderShow: false
            };
        },
        computed: {
            ...mapGetters(["getReturnGoodsList", "getExtraList"]),
            returnGoodsList()
            {
                return this.getReturnGoodsList.filter(f => f.Quantity > 0);
            },
            extraList()
            {
                return this.getExtraList.filter(f => f.Quantity > 0);
            },
            orderDetails:
            {
                get() {
                    return this.$store.getters.getOrderDetailsById(this.$attrs.id);
                },
                set(value) {
                    this.$store.commit(SETORDERDETAILS, value);
                }
            },
            filteredGoodsList() {
                return this.getReturnGoodsList.filter(f => f.Name.toLowerCase().includes(this.goodsSearch.toLowerCase()));
            },
            filteredExtraList() {
                return this.getExtraList.filter(f => f.Name.toLowerCase().includes(this.extraSearch.toLowerCase()));
            }
        },
        methods: {
            updateModalCompartmentsShow: function (event){
                this.orderShow = event;
            },
            updateOrderDetailsQuantity: function (dimensionId, quantity) {
                this.$store.commit(SETORDERDETAILS, { value: { quantity }, dimensionId});
            },
            updateOrderDetailsNote: function (dimensionId, note) {
                this.$store.commit(SETORDERDETAILS, { value: { note }, dimensionId});
            },
            updateReturnGoodsList: function (value, objectId) {
                this.$store.commit(SETRETURNGOOD, { value: value, objectId: objectId});
            },
            updateExtraList: function (value, objectId) {
                this.$store.commit(SETEXTRA, { value: value, objectId: objectId});
            },
            setFocusGoods: function () {
                if (this.filteredGoodsList[0]) {
                    const element = document.querySelector('#return_product' + this.filteredGoodsList[0].ObjectId + ' > input');
                    element.focus();
                }
            },
            setFocusExtra: function () {
                if (this.filteredExtraList[0]) {
                    const element = document.querySelector('#extra_product' + this.filteredExtraList[0].ObjectId + ' > input');
                    element.focus();
                }
            },
        }
    };
</script>

<style>
    .justify-content{
        justify-content: center;
    }
    @media(max-width: 400px){
        .product-col div{
            margin: 0px!important;
        }
        .bottle-col div{
            margin-top: 13px;
            margin-left: 0px!important;
        }
    }
    @media (min-width: 768px) and (max-width: 992px){
        .container{
            flex: 0 0 80%!important;
            max-width: 80%!important;
        }
    }
    @media (min-width: 400px) and (max-width: 992px){
        .justify-content{
            justify-content: start;
        }
        .product-col{
            flex: 0 0 50%!important;
            max-width: 75%!important;
        }
        .product-col div{
            margin: 0px!important;
        }
        .product-col div label{
            max-width: 100%!important;
        }
        .bottle-col{
            flex: 0 0 25%!important;
            max-width: 25%!important;
            padding-left: 5px!important;
        }
        .bottle-col div{
            margin-top: 13px;
            margin-left: 0px!important;
        }
    }
</style>